/*
 * @Description:
 */
import { useAppStore } from '@/store/useAppStore'
import utils from '..'
import xbb from '@xbb/xbb-utils'
import { checkVersion } from '../../api/login'
import UpdateTipsPromise from '@/utils/h5/update-tips-promise'
import xbbError from '@xbb/xbb-error'
import { createToast } from '@/components/toast/index.js'
// import { createDialog } from '@/components/dialog'

let backClick = 0
// 不显示返回键的主页面
const backPage = ['home', 'appLoginIndex']

// webview的id
const backWebview = ['fsLogin']

// 发送消息给uniapp
function sendMessageToUniapp(data) {
  if (!window.uni) return
  uni.postMessage({ data })
}

// 创建dialog
// function createCustomDialog(content, onConfirm) {
//   const dialog = createDialog({
//     text: content,
//     onConfirm,
//     confirmText: '确定'
//   })
//   dialog.show()
// }

/**
 * 1. 首页连续触发，退出应用
 * 2. 首页预览视频等，退出预览
 * 3. 非首页，返回上一个路由
 */
const h5BackPrep = function ({ route, router }) {
  console.log('🚀 ~ h5BackPrep ~ route:', route, router, useAppStore())
  const { isShowPreview, setIsShowPreview } = useAppStore()
  const routeName = route?.name
  // 存在webview则关闭webview
  const allWebview = window.plus.webview.all()
  const isWebview = allWebview.find((item) => backWebview.includes(item.id))
  if (isWebview) {
    const idWebview = window.plus.webview.getWebviewById(isWebview.id)
    idWebview.close()
    return
  }
  // 判断是否为各首页展示
  const isIndex = backPage.includes(routeName)
  if (isIndex) {
    if (window.uni) {
      uni.navigateBack()
    }

    if (isShowPreview) {
      setIsShowPreview(false)
      return
    }
    backClick++
    if (backClick > 1) {
      sendMessageToUniapp({ type: 'quitApp' })
      // window.plus.runtime.quit() // 向uni-app退出应用
      return
    } else {
      window.plus.nativeUI.toast('再按一次退出应用')
      setTimeout(function () {
        backClick = 0 // 两秒清除点击次数
      }, 1000)
    }
  } else {
    router.back()
  }
}

// 安卓设备安装错误回调
function errorCallBack(message) {
  const errorCatch = { name: 'app', message }
  window.plus.nativeUI.alert(errorCatch.message, '确认')
  xbbError.errorCatch(errorCatch, 0)
  window.plus.nativeUI.closeWaiting()
}

// 是否为最小版本差异
const isMinimumVersionDiff = function (preVersion, currentVersion) {
  const preArr = preVersion.split('.')
  const currentArr = currentVersion.split('.')
  return (
    Number(currentArr[0]) === Number(preArr[0]) && // 第一位相同
    Number(currentArr[1]) === Number(preArr[1]) && // 第二位相同
    Number(currentArr[2]) - Number(preArr[2]) === 1
  ) // 第三位版本差1
}

// 安装更新包
function install(vm, wgtVer, url, toast) {
  const errorCatch = { name: 'app', message: '' }
  utils.h5DownLoadFile({
    url,
    onProgress: (percent) => {
      if (toast) toast.setText(`升级中...${percent}%`)
    },
    onSuccess: (name) => {
      if (toast) toast.setText('安装中...')
      utils.h5InstallApp({
        name,
        onSuccess: (_) => {
          // 销毁弹窗
          vm.$remove()
          if (toast) toast.hide()
          // createCustomDialog('更新成功，点击确定重新启动应用', () => {
          //   window.plus.runtime.restart()
          // })
          window.plus.runtime.restart()
        },
        onFail: (e) => {
          // 失败时也销毁弹窗和toast
          vm.$remove()
          if (toast) toast.hide()
          errorCatch.message = `【${wgtVer}】安装wgt文件失败[${e.code}]：${e.message}`
          xbbError.errorCatch(errorCatch, 0)
          errorCallBack(`【${wgtVer}】安装wgt文件失败[${e.code}]：${e.message}`)
        }
      })
    },
    onFail: (_) => {
      // 失败时也销毁弹窗和toast
      vm.$remove()
      if (toast) toast.hide()
      errorCatch.message = `【${wgtVer}】下载wgt失败！`
      xbbError.errorCatch(errorCatch, 0)
      errorCallBack(`【${wgtVer}】下载wgt失败！`)
    }
  })
}

// 热更新
const h5ResourceUpgrade = async function (router) {
  // // 判断当前是否登录，未登录直接返回
  // if (!utils.xbbLocalStorageGet('xbbAccessToken')) return

  // 版本号
  let versionId = null
  utils.h5GetProperty((inf) => {
    // 检测是否是 应用商店下载
    utils.xbbLocalStorageSet('isAppStore', (inf.name.indexOf('xbb-pro-appstore') > -1) * 1)
    // 获取版本
    versionId = inf.version
    utils.xbbLocalStorageSet('wgtVer', versionId)
    const appPlatform = xbb.browser() // ios或者Android
    // if (appPlatform === 'ios' && !window.plus.runtime.isAgreePrivacy()) return
    if (!window.plus.runtime.isAgreePrivacy() && appPlatform === 'android') {
      router.push({ name: 'appLoginIndex' })
    }
    // 发起请求检测是否有新版本
    checkVersion({ appPlatform, versionId, appType: 2 })
      .then(({ result }) => {
        // 判断是否需要强制更新
        if (result.forceUpdate === 1) {
          UpdateTipsPromise(result).then(() => {
            utils.xbbOpenLink({ url: result.storePath })
          })
        } else {
          if (result.versionId !== '') {
            // 根据版本号差异，判断使用完整包还是增量包
            const wgtPath = isMinimumVersionDiff(versionId, result.versionId)
              ? result.wgtPath
              : result.storePath

            UpdateTipsPromise(result).then((vm) => {
              // 弹窗确认后，显示 toast
              const toast = createToast({
                txt: '升级中...',
                mask: true,
                duration: 0 // 不自动消失
              })
              toast.show()
              install(vm, versionId, wgtPath, toast)
            })
          }
        }
      })
      .catch(() => {})
  })
}

function throttle(func, wait) {
  let lastCall = 0

  return function (...args) {
    const now = new Date().getTime()
    if (now - lastCall < wait) {
      // 如果在间隔时间内再次触发事件，则不执行函数
      return
    }
    func.apply(this, args)
    lastCall = now
  }
}
const throttleH5ResourceUpgrade = throttle(h5ResourceUpgrade, 500)

export default {
  h5BackPrep,
  throttleH5ResourceUpgrade
}
